<template>
    <div id="contract_billing_frequency_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
            
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Contract Billing Frequency List
                        <router-link v-if="canAddBilling" class="btn btn-success waves-effect pull-right" v-bind:to="{name: 'ContractBillingFrequencyCreate'}" > <i class="hi-icon icon-flAdd"> </i> Add</router-link>
                    </div>
                    <div class="admin-page-content customer-detail">
                        <section class="internal-container border-top-table-fl">
                            <div class="container">
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'contractBillingFrequency'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listContractBillingFrequencyTable"
                                    mode="remote"
                                    title="ContractBillingFrequency"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                                <router-link title="Edit Contract Billing Frequency" v-if="canUpdateBilling" class="glyphicon glyphicon-edit" v-bind:to="{name: 'ContractBillingFrequencyEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="canRemoveBilling" id="deleteContractBillingFrequencyBtn" v-on:click.prevent="ContractBillingFrequencyDelete" class="btn btn-success waves-effect">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange">
                                </custom-pagination>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";


import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

import CustomPagination from '@/components/layout/CustomPagination';
Vue.component("custom-pagination", CustomPagination);

    export default {
        name: "ContractBillingFrequencyList",
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden:false,
                },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            canAddBilling:false,
            canUpdateBilling:false,
            canRemoveBilling:false,
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_contract_billing_frequency') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_contract_billing_frequency') {
                            self.canAddBilling = true;
                            self.canUpdateBilling = true;
                        }
                        if (permissions[i].name == 'delete_contract_billing_frequency') {
                            self.canRemoveBilling = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            //self.loadList();
            self.getPermissions();
        },
        methods: {

            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('code');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.code) {
                    this.loadList();
                }
            },*/
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/contractbillingfrequency/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'contract-billing-frequency-list')
                    }
                });
            },
            ContractBillingFrequencyDelete() {
                var data = this.$refs['listContractBillingFrequencyTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listContractBillingFrequencyTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Contract Billing Frequency? ')) {
                    self.loading = true;
                    $("#deleteContractBillingFrequencyBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/contractbillingfrequency/delete",
                        type: "POST",
                        data: 'ids=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteContractBillingFrequencyBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,false,'contract-billing-frequency-delete')
                        }
                    });
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ContractBillingFrequencyList.vue